/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { handleScroll } from './utils';

class ScrollableDragHandler {

	constructor(options) {
		this.scrollableContainer = options.scrollableContainer;
		this.priority = () => 10;
		this.dndManager = options.dndManager;
		this.receiveEventsWhenNotAccepting = true; // this is needed by dndManager
	}

	accepts = () => {
		return false;
	}

	onDragMove(dragObject, dropTarget, event) {
		handleScroll(event, this.scrollableContainer, () => this.dndManager && this.dndManager.reassessContainer(this.scrollableContainer));
	}
}

export default ScrollableDragHandler;


// WEBPACK FOOTER //
// ./src/js/ScrollableDragHandler.js